<template>
  <div style="width: 100%;">
    <div>教师占比</div>
    <div style="width:100%;display: flex;" class="four">
      <div id="four1" style="width:100%; height:200px; ">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props:{
    list3:Array
  },
  name: "",
  data() {
    return {

    }
  },
  mounted() {
    this.initBie()
  },
  methods: {
    initBie() {

      let chartDom = document.getElementById('four1');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: [
          '#5470c6',
          '#91cc75',
          '#fac858',
          '#ee6666',
          '#73c0de',
          '#3ba272',
          '#fc8452',
          '#9a60b4',
          '#ea7ccc'],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data:this.list3
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
    }
  },
  watch: {
    list3: {
      deep: true,
      handler (val) {
        this.initBie()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/statistics/components/income3.vue